import LogoImg from '@assets/svg/logo-gray.svg';
import WarningImg from '@assets/svg/warning.svg';

import {
  Overlay,
  Container,
  Header,
  Logo,
  Divider,
  Alert,
  Title,
  Description,
  Button,
  Row,
} from './OtherErrorAlert.styles';

const OtherErrorAlert = () => {
  return (
    <Overlay>
      <Container>
        <Header>
          <Row>
            <Logo src={LogoImg} alt="Logo" />
          </Row>

          <Divider />

          <Alert src={WarningImg} alt="Warning Sign" />

          <Title>Sorry, beam is offline.</Title>

          <Description>Please click below to try again</Description>
          {/* @ts-expect-error This is for firefox to make it clear its cache https://developer.mozilla.org/en-US/docs/Web/API/Location/reload */}
          <Button onClick={() => window.location.reload(true)}>
            Try Again
          </Button>
        </Header>
      </Container>
    </Overlay>
  );
};

export { OtherErrorAlert };
